// @flow

import React, { type ComponentType } from 'react';
import { connect } from 'react-redux';
import { getActivePdbId } from '../../store/pdb';

type InjectedProps = {|
  pdbId: ?string,
|};

function withActivePdbId <Props: {}>(
  WrappedComponent: ComponentType<Props>,
): ComponentType<$Diff<Props, InjectedProps>> {
  const mapStateToProps = (state): InjectedProps => ({
    pdbId: getActivePdbId(state),
  });

  const ActivePdbId = ({
    pdbId,
    ...restProps
  }: Props & InjectedProps) => (
    <WrappedComponent
      {...restProps}
      pdbId={pdbId}
    />
  );

  return connect(mapStateToProps)(ActivePdbId);
}

export default withActivePdbId;
